import axios from 'axios'

axios.defaults.baseURL = import.meta.env.VITE_BASE_URL

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(function (response) {
  window.dispatchEvent(new CustomEvent('apiLogs', {
    detail: {
      log: {
        type: 'response',
        status: response.status,
        statusText: response.statusText,
        message: response.data?.message ?? 'Successful response',
        url: response.config.url,
        date: new Date()
      }
    }
  }))

  return response
}, function (error) {
  window.dispatchEvent(new CustomEvent('apiLogs', {
    detail: {
      log: {
        type: 'error',
        status: error.response?.status ?? 500,
        statusText: error.response?.statusText ?? 'Error',
        message: error.response?.data?.message ?? 'Network error',
        url: error.response?.config?.url ?? error.config?.url,
        date: new Date()
      }
    }
  }))

  return Promise.reject(error)
})

axios.interceptors.response.use(null, function (error) {
  if (error.response?.status === 401) {
    localStorage.removeItem('auth_token')
    window.dispatchEvent(new Event('auth:logout'))
  }
  return Promise.reject(error)
})

export const appApi = {
  login: (token) => {
    return axios.post('/auth/login', { token })
  },
  getAccountInfo: () => {
    return axios.get('/account/info')
  },
  getBacktestingMockUser: () => {
    return axios.get('/account/backtesting-mock')
  },
  getBacktestingRealUser: () => {
    return axios.get('/account/backtesting-real')
  },
  getPapertestingUser: () => {
    return axios.get('/account/papertesting')
  },
  getTestingAccountData: (strategyType, symbol, subName, params = {}) => {
    return axios.get(`/test-account/${strategyType}/${symbol}/${subName}`, {
      params
    })
  },
  closeOrderByMarket: (symbol, orderId) => {
    return axios.get(`/orders/close-order-by-market/${symbol}/${orderId}`)
  },
  openOrderByRates: (symbol) => {
    return axios.get(`/orders/open-order-by-rates/${symbol}`)
  }
}

